module.exports = __webpack_public_path__ + "static/media/Jackson St, San Francisco, CA4.8fe75688.jpg";